import T from '.';
import styled from 'styled-components';

const Toggle = styled(T)``;

export default Toggle;
